<template>
  <div id="parentx">
    <vs-sidebar
      default-index="1"
      :hiddenBackground="doNotClose"
      color="primary"
      class="left-sidebar"
      spacer
      v-model="isSidebarActive"
      :click-not-close="doNotClose"
      :reduce="isSidebarReduced"
    >
      <div v-bar class="vs-scrollable">
        <div>
          <div
            class="sidebar-header"
            :style="{
              background: `url(${require('@/assets/images/background/default-poster.png')})`,
            }"
          >
            <div class="buttons-container">
              <div class="username-container text-white">
                <span class="material-icons">person</span>
                <span class="username-text">{{ username }}</span>
              </div>
              <button class="sign-out" @click="logout">
                <span class="icon material-icons">power_settings_new</span>
              </button>
            </div>
          </div>
          <div class="sidebar-container">
            <recursive-menu-item
              v-for="item in menuItems"
              :key="item.code"
              :item="item"
              :redirect-link="redirectLink"
              :is-sub-link-active="isSubLinkActive"
              v-model:active-index="activeIndex"
            />
          </div>
        </div>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import { clearSession } from '@/axiosConfig'
import { ROUTES } from '@/global/api_routes'
import { SESSION_VARS } from '@/global/constants'
import RecursiveMenuItem from './RecursiveMenuItem.vue'

export default {
  name: 'SideBar',
  components: {
    RecursiveMenuItem,
  },
  data: () => ({
    microservice: 'SAFE',
    doNotClose: false,
    windowWidth: window.innerWidth,
    round: true,
    menuItems: [],
    email: null,
    username: null,
    activeIndex: null,
  }),
  computed: {
    isSidebarActive: {
      get() {
        return this.$store.state.isSidebarActive
      },
      set(val) {
        this.$store.commit('IS_SIDEBAR_ACTIVE', val)
      },
    },
    reduceSidebar() {
      return Boolean(this.isSidebarReduced)
    },
    isSidebarReduced: {
      get() {
        return this.$store.state.isSidebarReduced
      },
      set(val) {
        this.$store.commit('TOGGLE_REDUCE_SIDEBAR', val)
      },
    },
    isSubLinkActive() {
      return (sidebarLink) => {
        let open = false
        if (sidebarLink.child) {
          sidebarLink.child.forEach((link) => {
            if (this.$route.fullPath == link.url) {
              open = true
            }
          })
        }
        return open
      }
    },
  },
  mounted() {
    this.listMenu()
    this.email = localStorage.getItem(SESSION_VARS.EMAIL)
    this.username = localStorage.getItem(SESSION_VARS.USERNAME)
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleWindowResize)
    })
    this.setSidebarWidth()
  },
  watch: {
    $route() {
      if (this.windowWidth < 1170) {
        this.$store.commit('IS_SIDEBAR_ACTIVE', false)
      }
    },
  },
  methods: {
    listMenu() {
      const menuInfo = localStorage.getItem(SESSION_VARS.MENU)
      if (menuInfo) {
        this.menuItems = JSON.parse(menuInfo)
        return
      }
      this.$http.get(ROUTES.DASHBOARD.GET_MENU).then(({ data }) => {
        if (data.code > 0) {
          this.menuItems = data.info
          localStorage.setItem(SESSION_VARS.MENU, JSON.stringify(data.info))
        }
        this.isLoading = false
      })
    },
    logout() {
      try {
        clearSession()
      } catch (error) {
        console.log(error)
      }
      location.href = '/view/login'
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth
      this.setSidebarWidth()
    },
    setSidebarWidth() {
      if (this.windowWidth < 1170) {
        this.$store.commit('IS_SIDEBAR_ACTIVE', false)
        this.doNotClose = false
        this.$store.dispatch('updateSidebarWidth', 'no-sidebar')
      } else {
        this.$store.commit('IS_SIDEBAR_ACTIVE', true)
        this.doNotClose = true
        if (this.isSidebarReduced) {
          this.$store.dispatch('updateSidebarWidth', 'mini')
        } else {
          this.$store.dispatch('updateSidebarWidth', 'default')
        }
      }
    },
    redirectLink(app) {
      return app.microservice === this.microservice
        ? app.url
        : location.origin + app.url
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize)
    this.setSidebarWidth()
  },
}
</script>

<style>
.group-name {
  font-size: 1.125rem !important;
}
.buttons-container {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .username-container {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    line-height: 1.1em;

    .material-icons {
      font-size: 2rem;
    }
  }
}

.username-container {
  text-shadow: 0 1px 1px #5b5b5b;
  max-width: 100%;
  min-width: 0;
  
  .material-icons {
    font-size: 1.4rem !important;
  }
  
  .username-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
  }
}

.sign-out {
  text-shadow: 0 1px 1px #5b5b5b;
  flex-shrink: 0;
}
</style>
